import { render } from "./SlotBadges.vue?vue&type=template&id=73cc81d3&scoped=true"
import script from "./SlotBadges.vue?vue&type=script&lang=js"
export * from "./SlotBadges.vue?vue&type=script&lang=js"

import "./SlotBadges.vue?vue&type=style&index=0&id=73cc81d3&scoped=true&lang=css"
import "./SlotBadges.vue?vue&type=style&index=1&id=73cc81d3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cc81d3"]])

export default __exports__